query ListBimClasses {
    bimClasses(
        filter: {
            tag: "latest"
        }
    ) {
        id
        revisionID
        data {
            name(language: "en") {
                text
            }
        }
        metadata {
            deprecated
            tags
        }
    }
}
